import { createContext, type ReactNode,useContext } from 'react'

interface BootstrapContextValue {
	/** True after session (tabs, node state) has been applied to the store. */
	sessionProcessed: boolean
}

const BootstrapContext = createContext<BootstrapContextValue>({
	sessionProcessed: true,
})

export const BootstrapProvider = ({
	children,
	sessionProcessed,
}: {
	children: ReactNode
	sessionProcessed: boolean
}) => (
	<BootstrapContext.Provider value={{ sessionProcessed }}>
		{children}
	</BootstrapContext.Provider>
)

export const useBootstrap = () => useContext(BootstrapContext)
